import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { PrePaidLicenseInformation } from '../../types/PrePaidLicenseInformation';

export abstract class LicensePrePaidSubFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getLicenseKeyInfo(
    licenseKeyFieldValue: string,
    companyId: string | null,
    returnIncompatibleProducts: boolean
  ): Promise<PrePaidLicenseInformation>;

  public abstract getRootVisibilityTree(): Promise<string>;
}
